import {
  Component, Input, ViewContainerRef, ComponentFactoryResolver, ViewChild, OnChanges,
  ComponentRef, OnInit, SimpleChanges, Output, EventEmitter, Injector, ReflectiveInjector, ComponentFactory
} from '@angular/core';
import { ComponentMap } from '../dg-component-map';
import { ViewElement, ViewElementCollection } from '../../common/view';
import {
  AppContext,
  BindingData, Form, FrameContext, FRAME_ID, IViewContext, NAMESPACE, RenderAppContext,
  Repository, StateMachine, UIState, ViewModel
} from '@farris/devkit';
import { BefLookupRestService, DefaultComboHttpService } from '@farris/bef';
// import { DYNAMIC_FARRIS_COMMAND_SERVICE_PROVIDERS, FARRIS_COMMAND_SERVICE_FRAME_PROVIDERS } from '@farris/command-services';
import { DomDocumentService } from '../../common/service/dom-document.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { ServerSideToken } from '@farris/ui-lookup';
import { ComboServerSideToken } from '@farris/ui-combo-list';
import { DgComponentMapModule } from '../dg-component-map.module';


declare const System: any;

/**
 * 视图内的包装容器
 */
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'dg-wrapper',
  templateUrl: './dg-wrapper.component.html',
  styleUrls: ['./dg-wrapper.component.css']
})
export class DgWrapperComponent implements OnInit, OnChanges {

  @Input() type = 'VerticalFilled';
  /**
   * 所属元素标识
   */
  @Input() ownerId: string;
  /**
   * 渲染元素集合
   */
  @Input() viewElements: ViewElementCollection;
  /**
   * 渲染上下文对象
   */
  @Input() renderContext: RenderAppContext;
  /**
   * 包装容器
   */
  @ViewChild('dgwrapper', { read: ViewContainerRef }) dgWrapper: ViewContainerRef;

  @Output() componentCreated = new EventEmitter<ViewElement>();

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private domDocumentService: DomDocumentService,
    private injector: Injector
  ) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    const elementChanges = changes.viewElements;
    if (elementChanges && elementChanges.previousValue !== elementChanges.currentValue) {
      this.innerRender(this.viewElements);
    }
  }
  /**
   * 内部渲染方法
   * @param template 待渲染元素集合
   */
  private innerRender(viewElements: ViewElementCollection) {
    if (viewElements && viewElements.elements) {
      viewElements.elements.forEach(element => this.appendElement(element));
      viewElements.elementAppended.subscribe(element => {
        this.appendElement(element);
      });
      viewElements.elementRemoved.subscribe(index => {
        this.removeElement(index);
      });

    }
  }
  /**
   * 向包装容器内添加视图元素
   * @param element 待添加元素
   */
  private appendElement(element: ViewElement) {
    const elementType = element.type;
    // if (ComponentMap[elementType]) {
    //   const componentType = ComponentMap[elementType].type;
    //   const componentProcessor = ComponentMap[elementType].processor;
    //   const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);
    //   let componentRef: ComponentRef<any>;
    //   if (elementType === 'ExternalContainer') {
    //     const cmpId = element.externalCmp;
    //     const externalCmp = this.domDocumentService.getExternalComponent(cmpId);
    //     const metadataPath = '/' + externalCmp.filePath + '/' + externalCmp.fileName;
    //     componentRef = this.dgWrapper.createComponent(componentFactory);
    //     componentRef.instance.cmpType = 'externalComponent';
    //     componentRef.instance.extendsFormMetadata = metadataPath;
    //   } else if (elementType === 'Component') {
    //     const viewComponentContext = this.renderContext.getContextById(element.id) as IViewContext;
    //     const componentProviders = [
    //       { provide: FRAME_ID, useValue: element.id },
    //       { provide: BindingData, useValue: viewComponentContext.bindingData },
    //       { provide: Repository, useValue: viewComponentContext.repository },
    //       { provide: NAMESPACE, useValue: viewComponentContext.namespace },
    //       { provide: Form, useValue: viewComponentContext.form },
    //       { provide: StateMachine, useValue: viewComponentContext.stateMachine },
    //       { provide: UIState, useValue: viewComponentContext.uiState },
    //       { provide: ViewModel, useValue: viewComponentContext.viewModel },
    //       { provide: FrameContext, useValue: viewComponentContext },
    //       { provide: AppContext, useValue: viewComponentContext.appContext },
    //       // FARRIS_COMMAND_SERVICE_FRAME_PROVIDERS,
    //       // DYNAMIC_FARRIS_COMMAND_SERVICE_PROVIDERS
    //     ];
    //     const componentInjector = ReflectiveInjector.resolveAndCreate(componentProviders, this.injector);
    //     viewComponentContext.bindInjector(componentInjector);
    //     componentRef = this.dgWrapper.createComponent(componentFactory, null, componentInjector);
    //   } else {
    //     componentRef = this.dgWrapper.createComponent(componentFactory);
    //   }
    //   if (componentProcessor) {
    //     componentProcessor(componentRef, element, this.renderContext);
    //   }
    //   element.setComponentRef(componentRef);
    //   this.componentCreated.emit(element);
    // }
    this.resolveComponentFactoryFromElementType(elementType).subscribe(componentFactory => {
      if (componentFactory) {
        const componentProcessor = ComponentMap[elementType].processor;
        let componentRef: ComponentRef<any>;
        if (elementType === 'ExternalContainer') {
          const cmpId = element.externalCmp;
          const externalCmp = this.domDocumentService.getExternalComponent(cmpId);
          const metadataPath = '/' + externalCmp.filePath + '/' + externalCmp.fileName;
          componentRef = this.dgWrapper.createComponent(componentFactory);
          componentRef.instance.cmpType = 'externalComponent';
          componentRef.instance.extendsFormMetadata = metadataPath;
        } else if (elementType === 'Component') {
          const viewComponentContext = this.renderContext.getContextById(element.id) as IViewContext;
          const componentProviders = [
            { provide: FRAME_ID, useValue: element.id },
            { provide: BindingData, useValue: viewComponentContext.bindingData },
            { provide: Repository, useValue: viewComponentContext.repository },
            { provide: NAMESPACE, useValue: viewComponentContext.namespace },
            { provide: Form, useValue: viewComponentContext.form },
            { provide: StateMachine, useValue: viewComponentContext.stateMachine },
            { provide: UIState, useValue: viewComponentContext.uiState },
            { provide: ViewModel, useValue: viewComponentContext.viewModel },
            { provide: FrameContext, useValue: viewComponentContext },
            { provide: AppContext, useValue: viewComponentContext.appContext },
            { provide: ServerSideToken, useClass: BefLookupRestService },
            { provide: ComboServerSideToken, useClass: DefaultComboHttpService },
            // FARRIS_COMMAND_SERVICE_FRAME_PROVIDERS,
            // DYNAMIC_FARRIS_COMMAND_SERVICE_PROVIDERS
          ];
          const componentInjector = ReflectiveInjector.resolveAndCreate(componentProviders, this.injector);
          viewComponentContext.bindInjector(componentInjector);
          componentRef = this.dgWrapper.createComponent(componentFactory, null, componentInjector);
        } else {
          componentRef = this.dgWrapper.createComponent(componentFactory);
        }
        if (componentProcessor) {
          componentProcessor(componentRef, element, this.renderContext);
        }
        element.setComponentRef(componentRef);
        this.componentCreated.emit(element);
      }
    });
  }

  private resolveComponentFactoryFromElementType(elementType: string): Observable<ComponentFactory<any>> {
    const result = new BehaviorSubject<ComponentFactory<any>>(null);
    if (ComponentMap[elementType]) {
      let componentFactory: ComponentFactory<any> = null;
      if (ComponentMap[elementType].type) {
        const componentType = ComponentMap[elementType].type;
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);
        result.next(componentFactory);
      } else if (ComponentMap[elementType].sourceUri) {
        const componentSpecifer = ComponentMap[elementType].sourceUri;
        const componentTypeName = ComponentMap[elementType].typeName;
        System.import(componentSpecifer)
          .then((data: any) => {
            const moduleKey = Object.keys(data).length ? Object.keys(data)[0] : null;
            if (moduleKey) {
              const componentModuleFactory = data[moduleKey];
              const componentModule = componentModuleFactory.create(this.injector);
              const componentFactoryResolver = componentModule.componentFactoryResolver;
              const componetModuleInstance = componentModule.instance as DgComponentMapModule;
              const componentType = componetModuleInstance.getDgComponentByTypeName(componentTypeName);
              if (componentType) {
                componentFactory = componentFactoryResolver.resolveComponentFactory(componentType);
                result.next(componentFactory);
              } else {
                throw new Error(`Could not find any component type '${componentTypeName}'.`);
              }
            } else {
              throw new Error('Could not find any component module.');
            }
            // const componentModuleFactory = data.AppModuleNgFactory;
            // const componentModule = componentModuleFactory.create(this.injector);
            // const componentFactoryResolver = componentModule.componentFactoryResolver;
            // componentFactory = componentFactoryResolver.resolveComponentFactory(componentModule._bootstrapComponents[0]);
            // result.next(componentFactory);
          });
      }
    }
    return result;
  }
  /**
   * 从包装元素内移除元素
   * @param index 待移除元素索引
   */
  private removeElement(index) {
    this.dgWrapper.remove(index);
  }
  /**
   * 清空视图内容
   */
  clear() {
    this.dgWrapper.clear();
  }
}
